import { render, staticRenderFns } from "./LaunchGameMobile.vue?vue&type=template&id=e5118106&scoped=true&"
import script from "./LaunchGameMobile.vue?vue&type=script&lang=js&"
export * from "./LaunchGameMobile.vue?vue&type=script&lang=js&"
import style0 from "./LaunchGameMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LaunchGameMobile.vue?vue&type=style&index=1&id=e5118106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5118106",
  null
  
)

export default component.exports